"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntersectionEngine = void 0;
const IntersectionEngine_1 = require("./implementation/IntersectionEngine");
Object.defineProperty(exports, "IntersectionEngine", { enumerable: true, get: function () { return IntersectionEngine_1.IntersectionEngine; } });
//# sourceMappingURL=index.js.map